/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import resetIcon from '../../../images/Autocode/reset_icon.svg';

const ACToggleSwitch = (props) => {
  const { title, optionList, handleSwitch, checkedValue, child, resetSelection, isDisabled } = props;
  return (
    <div className="ac-radio-panel">
      <div className="ac-radio-panel-title">
        <span className="ac-radio-panel-title-name">{title}</span>
        {resetSelection && <span className="ac-radio-panel-title-icon"
          onClick={() => resetSelection(title)}><img src={resetIcon} alt="reset"/></span>}
      </div>
      <div className="ac-radio-panel-body" onClick={e => {
        e.stopPropagation()
      }}>
        {optionList && optionList.map((res, i) => (
          <p className="ac-radio-btn">
            <input
              type="radio"
              className="hidden-box"
              id={res.label}
              name={title}
              checked={i===checkedValue}
              onChange={e => handleSwitch(title, i, res.funcName, e)}
              disabled={isDisabled}
            />
            <label htmlFor={res.label} className="check--label">
              <div style={{ display: 'flex' }}>
                <div>
                  <span className={classNames('check--label-box',
                   { 'check--label-box-disabled': isDisabled })} />
                </div>
                <div
                  className={classNames('check--label-text', {
                    'check--label-text-selected': i === checkedValue,
                  }, { 'disabled-text': isDisabled })}
                >
                  {res.label}{child ? child[i] : ''}
                </div>
              </div>
            </label>
          </p>
        ))}
      </div>
    </div>
  );
};

ACToggleSwitch.propTypes = {
  title: PropTypes.string,
  handleSwitch: PropTypes.func,
  optionList: PropTypes.instanceOf(Array),
  child: PropTypes.instanceOf(Array),
  checkedValue: PropTypes.number,
  resetSelection: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default ACToggleSwitch;
